import { render } from "./OrderDetailsDebug.vue?vue&type=template&id=4a7a171e"
import script from "./OrderDetailsDebug.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDebug.vue?vue&type=script&lang=js"

import "./OrderDetailsDebug.vue?vue&type=style&index=0&id=4a7a171e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__